import * as types from "../actions/actionTypes";
const initialState = {
    loading: true,
    error: false,
    data: [],
};

const CountryCode = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_CURRENCIES_REQUEST:
            return { ...state, loading: true, error: false };
        case types.GET_CURRENCIES_SUCCESS:
            return { ...state, data: action.payLoad, loading: false };
        case types.GET_CURRENCIES_FAILURE:
            return { ...state, loading: false, error: true };
        default:
            return state;
    }
};

export default CountryCode;
